export default class Dispatcher {
  constructor(object) {
    this.callbacks = {};
    
    if (object) {
      object.on = (...data) => this.on(...data);
      object.once = (...data) => this.once(...data);
      object.off = (...data) => this.off(...data);
      object.trigger = (...data) => this.trigger(...data);
    } 
  }

  on(eventName, callback) {
    if (!this.callbacks[eventName]) this.callbacks[eventName] = [];
    let cb = data => callback(data);
    this.callbacks[eventName].push(cb);
  }

  once(eventName, callback) {
    if (!this.callbacks[eventName]) this.callbacks[eventName] = [];
    let cb = data => {
      callback(data);
      this.off(eventName, cb);
    }
    this.callbacks[eventName].push(cb);
  }

  off(eventName, callback) {
    if (this.callbacks[eventName]) {
      let index = this.callbacks[eventName].indexOf(callback);
      if (index !== -1) {
        this.callbacks[eventName].splice(index, 1);
      }
    }
  }

  trigger(eventName, data) {
    let cbs = this.callbacks[eventName];
    if (cbs) {
      cbs.forEach(cb => {
        let off = () => this.off(eventName, cb)
        cb(data, off);
      });
    }
  }
}